export const REQUEST_AUTH = "REQUEST_AUTH";
export const REQUEST_SESSION = "REQUEST_SESSION";
export const SET_USER = "SET_USER";
